import config from 'config';
import { DateTime } from 'luxon';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { decodeUrlParams } from 'utils/url-params';
import type { State } from './global.types';
import * as actionTypes from './global.types';

const urlState = decodeUrlParams(window.location.search);
export const initialState: State = {
  isUserIdle: false,
  isUserOnline: true,
  idleSince: null,
  initializedAt: null,
  initializedAssetRevision: window.ASSETS_REVISION || null,
  availableAssetRevision: window.ASSETS_REVISION || null,
  requestedAssetRevision: urlState.revision || null,
  showKeyboardShortcutModal: false,
  electronUpdateStatus: null,
  datePickerDropdown: {
    isRange: true,
  },
  clientReportDatePickerDropdown: {
    isRange: true,
  },
  detectedTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
};

const reducer = reducerWithInitialState<State>(initialState)
  .case(actionTypes.completeGlobalFetch, (state): State => {
    return {
      ...state,
      initializedAt: DateTime.now().toISO(),
    };
  })
  .case(actionTypes.toggleKeyboardShortcutModal, (state): State => {
    return {
      ...state,
      showKeyboardShortcutModal: !state.showKeyboardShortcutModal,
    };
  })
  .case(actionTypes.setUserAsIdle, (state, payload): State => {
    const isIdle = payload;
    const idleSince = isIdle
      ? DateTime.now().minus({ minutes: config.idleAfterMinutes }).toISO()
      : null;

    return {
      ...state,
      isUserIdle: payload,
      idleSince,
    };
  })
  .case(actionTypes.setUserIsOnline, (state, payload): State => {
    return {
      ...state,
      isUserOnline: payload,
    };
  })
  .case(actionTypes.setElectronUpdateStatus, (state, payload): State => {
    return {
      ...state,
      electronUpdateStatus: payload,
    };
  })
  .case(actionTypes.setAvailableAssetRevision, (state, payload): State => {
    return {
      ...state,
      availableAssetRevision: payload,
    };
  })
  .case(actionTypes.setInitializedAssetRevisionForDevTool, (state, payload): State => {
    return {
      ...state,
      initializedAssetRevision: payload,
    };
  })
  .case(actionTypes.toggleDatePickerDropdownRangeMode, (state): State => {
    return {
      ...state,
      datePickerDropdown: {
        ...state.datePickerDropdown,
        isRange: !state.datePickerDropdown.isRange,
      },
    };
  })
  .case(actionTypes.toggleClientReportDatePickerRangeMode, (state): State => {
    return {
      ...state,
      clientReportDatePickerDropdown: {
        ...state.clientReportDatePickerDropdown,
        isRange: !state.clientReportDatePickerDropdown.isRange,
      },
    };
  })
  .case(actionTypes.setDetectedTimezone, (state, payload): State => {
    return {
      ...state,
      detectedTimezone: payload,
    };
  });

export default reducer;
